import { Injectable } from '@angular/core';
import { Parameter } from 'projects/common/src/app/classes';
import { IPermission } from 'projects/common/src/app/interfaces';
import { NotificationHandlerService } from 'projects/common/src/app/services';
import { take, filter, map } from 'rxjs/operators';
import { ISession } from 'projects/common/src/app/interfaces/authentication';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PermissionService extends Parameter<IPermission[]> {
  constructor(protected notificationService: NotificationHandlerService) {
    super();
    this.name = 'permission';
  }

  public init(): Promise<IPermission[]> {
    this.alreadyStarted = true;
    return new Promise((resolve) => {
      this.sourceSubject.pipe(take(1)).subscribe((arg0) => resolve(arg0));
    });
  }

  public startWhen(source: Observable<ISession>): void {
    this.subscription = source
      .pipe(
        filter((data) => !!data),
        map((data) => data.permissions),
      )
      .subscribe((data) => {
        this.alreadyStarted = true;
        this.set(data);
      });
  }

  public canView(object: string): boolean {
    const permissions = this.get();
    const found = permissions.find((value) => value.object === object);
    return found && found.permission === 'ACTIVAR';
  }

  /**
   * validate have permission to display component or modal
   * @param permission
   */
  public havePermission(permission: IPermission[]): boolean {
    const permised = !!permission.find((value) => value.object === 'ESTADO' && value.permission === 'MODIFICAR');
    return permised;
  }

  /**
   * Find permissions by object key.
   *
   * @param object Object key to find.
   * @returns Array of permissions found.
   */
  public getPermissionsByObj(object: string): IPermission[] {
    return this.target.filter((value) => value.object.toLowerCase() === object.toLowerCase());
  }

  public getPermissionByType(type: string): IPermission[] {
    return this.target.filter((value) => value.permission.toLowerCase() === type.toLowerCase());
  }
}
